import { Select, MenuItem } from "@mui/material";

import type { Image as ImageType } from "@/types/serie";

const Selector = ({
  images,
  selectedImageIndex,
  onSelectedImageChange,
}: {
  images: ImageType[];
  selectedImageIndex: number;
  onSelectedImageChange: (index: number) => void;
}) => {
  return (
    <Select
      sx={{ width: "100%" }}
      value={selectedImageIndex}
      onChange={(e) => {
        onSelectedImageChange(Number(e.target.value));
      }}
    >
      {images.map((image, index) => (
        <MenuItem key={image.url} value={index}>
          {image.name}
        </MenuItem>
      ))}
    </Select>
  );
};

const ImageSelector = ({
  images,
  selectedImageIndex,
  onSelectedImageChange,
}: {
  images: ImageType[];
  selectedImageIndex: number;
  onSelectedImageChange: (index: number) => void;
}) => {
  if (images.length <= 1) return null;

  return (
    <Selector
      images={images}
      selectedImageIndex={selectedImageIndex}
      onSelectedImageChange={onSelectedImageChange}
    />
  );
};

export default ImageSelector;
